<header>
    <kin-icon [name]="icon()" />
    <h2>{{ title() | translate }}</h2>
</header>

<div class="field">
    @if(description()){
    <p class="element-description">{{ description() | translate }}</p>
    }
    <ng-content />
</div>